import { type RouteRecordRaw } from 'vue-router'

export const ResetAppRouter: RouteRecordRaw[] = [
  {
    path: '/reset',
    component: async () => import('./ResetApp.vue'),
  },
]
